// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressDrawerContainerStyles } from "@insite/content-library/Widgets/Header/AddressDrawerContainer"
import { css } from "styled-components";

addressDrawerContainerStyles.fulfillmentMethodGridItem = {
    css: css`
        order: 1;
    `,
    width: [12, 12, 2, 2, 2],
};
addressDrawerContainerStyles.addressesGridItem = {
    css: css`
        order: 2;
    `,
    width: [12, 12, 5, 5, 5],
};
addressDrawerContainerStyles.addressesGridItemAnonymousUser = {
    css: css`
        order: 3;
    `,
    width: [12, 12, 5, 5, 5],
};
addressDrawerContainerStyles.pickUpAddressGridItem = {
    css: css`
        order: 3;
    `,
    width: [12, 12, 5, 5, 5],
};
addressDrawerContainerStyles.pickUpAddressGridItemAnonymousUser = {
    css: css`
        order: 2;
    `,
    width: [12, 12, 5, 5, 5],
};
addressDrawerContainerStyles.applyButtonGridItem = {
    css: css`
        order: 4;
    `,
    width: [12, 12, 7, 7, 7],
};

